import AuthRequestHelper from './AuthRequestHelper'

class AIChatHelper {
    async sendMessage({ conversationId = null, systemMessage = null, messages = [], bot_id = null, model = null, room_id = null } = {}){
        const requestUrl = 'aichat'
        const body = {
            conversation_id: conversationId,
            system_message: systemMessage,
            messages: messages
        }
        if (bot_id) body.bot_id = bot_id
        if (model) body.model = model
        if (room_id) body.room_id = room_id
        // Let errors bubble so caller can handle and show details
        return await AuthRequestHelper.request('post', requestUrl, body)
    }

    async getConversation(conversationId){
        if(!conversationId) return null
        const requestUrl = `aichat/${conversationId}`
        try{
            return await AuthRequestHelper.request('get', requestUrl, {})
        }catch(e){
            throw e
        }
    }

    async getOrCreateForBot(botId){
        if(!botId) return null
        const requestUrl = `aichat?bot_id=${encodeURIComponent(botId)}`
        try{
            return await AuthRequestHelper.request('get', requestUrl, {})
        }catch(e){
            throw e
        }
    }

    async getRecentConversations(limit = 50, offset = 0){
        const requestUrl = `aichat/recent`
        try{
            return await AuthRequestHelper.request('get', requestUrl, { limit, offset })
        }catch(e){
            throw e
        }
    }
}

export default new AIChatHelper()
